'use client';

import { AllHTMLAttributes, ReactNode } from 'react';

import {
  wrapperStyle,
  middleStyle,
  beforeStyle,
  afterStyle,
  titleStyle,
  headStyle
} from '@/components/common/Cell/styles.ts';

interface CellProps extends AllHTMLAttributes<HTMLElement> {
  subhead?: ReactNode;
  children?: ReactNode;
  before?: ReactNode;
  after?: ReactNode;
  subtitle?: ReactNode;
}

export const Cell = ({
  children,
  subhead,
  before,
  after,
  subtitle
}: CellProps) => {
  return (
    <div style={{ ...wrapperStyle }}>
      {before && <div style={beforeStyle}>{before}</div>}
      <div style={middleStyle}>
        {subhead && <p style={{ margin: 0 }}>{subhead}</p>}
        {children && (
          <p style={{ ...headStyle, margin: 0 }}>
            {children && <span style={titleStyle}>{children}</span>}
          </p>
        )}
        {subtitle && (
          <p style={{ margin: '2px 0', color: '#808080' }}>{subtitle}</p>
        )}
      </div>
      {after && <div style={afterStyle}>{after}</div>}
    </div>
  );
};
